/** Shared layout classes for authenticated admin pages */
export const pageShellClass =
  "min-h-screen bg-[#F6F8FB] font-sans ml-0 lg:ml-[280px] transition-all duration-300 pt-[calc(3.5rem+env(safe-area-inset-top))] pb-[calc(4.5rem+env(safe-area-inset-bottom))] lg:pt-0 lg:pb-0";

export const pageShellLoadingClass =
  "h-screen flex flex-col items-center justify-center bg-[#F6F8FB] ml-0 lg:ml-[280px] pt-[calc(3.5rem+env(safe-area-inset-top))] pb-[calc(4.5rem+env(safe-area-inset-bottom))] lg:pt-0 lg:pb-0";

export const pageContentClass = "p-4 sm:p-6 lg:p-10 w-full max-w-[1600px] mx-auto";
